import { createServiceAction } from '../util/actionHelper.js';
import { apiConfig } from '../configs/apiConfig.js';
import { putRequest, displayMessage } from '../util/index.js';
import { getHTTPStatusValidationMessage, getServerValidationMessage } from '../services/serverValidations.js';
import { put, takeEvery, call } from 'redux-saga/effects';

function* listener(serviceType, action) {
  try {
    yield put(createServiceAction(serviceType, 'loading')());
    if (action.data) {
      const options = {
        id: action.data.materialId,
        isActive: action.data.status
      };

      const infoPopDuration = 1000;
      let url = apiConfig.editMaterialStatus.endPointUrl;
      const res = yield call(putRequest, url, options);
      // Display HTTP status error message
      const statusErrorMessage = yield call(getHTTPStatusValidationMessage, res, infoPopDuration);
      if (!statusErrorMessage) {
        const response = yield res.json();
        // Display server error message
        const serverErrorMessage = yield call(getServerValidationMessage, response, infoPopDuration);
        if (!serverErrorMessage && response.errorCode === 0) {
          yield put( createServiceAction('materialDetails', 'requested')())
          const message = `${response.message}`;
          // Display success message
          yield call(displayMessage, 'success', message, 1000);
        }
      }
    }
  } catch (e) {
    yield put(createServiceAction(serviceType, 'error')(e));
  }
}

function* changeMaterialStatusSagas() {
  const serviceType = 'changeMaterialStatus';
  yield takeEvery(createServiceAction(serviceType, 'submitted').type, listener, serviceType);
}

export default changeMaterialStatusSagas;
